export const selectIsMuted = store => {
  return store.settings.isMuted;
};
